import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authFeature, AuthEffects } from './features/auth/state';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { i18nFeature, I18nEffects } from './shared/i18n';
import { layoutFeature, LayoutEffects } from './shared/components/layout/state';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideStore({
      [authFeature.name]: authFeature.reducer,
      [i18nFeature.name]: i18nFeature.reducer,
      [layoutFeature.name]: layoutFeature.reducer,
    }),
    provideEffects([AuthEffects, I18nEffects, LayoutEffects]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideTranslateService({ fallbackLang: 'es' }),
    provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
  ],
};
